// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  designation: icon('ic_designation'),
  city: icon('ic_city'),
  dashboard: icon('ic_dashboard'),
};

const navConfig = [
  {
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.general.overview,
        icon: ICONS.dashboard,
      },
    ],
  },
  {
    subheader: 'management',
    items: [
      {
        title: 'Member Management',
        path: PATH_DASHBOARD.member.root,
        icon: ICONS.user,
        children: [
          {
            title: 'Member',
            path: PATH_DASHBOARD.member.list,
          },
        ],
      },
    ],
  },
  {
    subheader: 'configuration',
    items: [
      {
        title: 'Post',
        path: PATH_DASHBOARD.post.list,
        icon: ICONS.blog,
      },
      {
        title: 'Designation',
        path: PATH_DASHBOARD.designationinassociation.list,
        icon: ICONS.designation,
      },
      {
        title: 'City',
        path: PATH_DASHBOARD.city.list,
        icon: ICONS.city,
      },
      {
        title: 'Upload Document',
        path: PATH_DASHBOARD.uploadDocument.root,
        icon: ICONS.file,
      },
    ],
  },
];

export default navConfig;
